import { render, staticRenderFns } from "./JjBtnUpload.vue?vue&type=template&id=2d4cd8f0&scoped=true"
import script from "./JjBtnUpload.vue?vue&type=script&lang=js"
export * from "./JjBtnUpload.vue?vue&type=script&lang=js"
import style0 from "./JjBtnUpload.vue?vue&type=style&index=0&id=2d4cd8f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4cd8f0",
  null
  
)

export default component.exports